<template>
    <v-card-text class="mt-2">
        <v-row class="mb-3">
            <v-col cols="3" class="d-flex align-center justify-end">
                <h3>Titre :</h3>
            </v-col>
            <v-col cols="8">
                <v-text-field-filled
                    v-model="newAudit.title"
                    hide-details
                    outlined
                    label="Titre du contrôle"
                    :disabled="newAudit.type !== 'ACCOUNTING_REVIEW_MANUAL_CUSTOM'"
                    density="compact"
                />
            </v-col>
            <v-col cols="1" />
        </v-row>
        <v-row class="mb-3" v-if="newAudit.data.description">
            <v-col cols="1" />
            <v-col cols="10" class="d-flex align-center justify-center">
                <!-- <h3>Description :</h3> -->
                <!-- </v-col>
            <v-col cols="8"> -->
                <!-- <v-textarea
                    v-model="newAudit.data.description"
                    dense
                    hide-details
                    outlined
                    class="oss-"
                    :disabled="true"
                    auto-grow
                    rows="1"
                ></v-textarea> -->
                <h3 class="text-center">{{ newAudit.data.description }}</h3>
            </v-col>
            <v-col cols="1" />
        </v-row>
        <v-row v-if="!newAudit.data.description" class="mb-3">
            <v-col cols="3" class="d-flex align-center justify-end">
                <h3>Comptes à afficher :</h3>
            </v-col>
            <v-col cols="8">
                <v-combobox-filled
                    v-model="newAudit.data.accountableAccounts"
                    label="Racines comptes"
                    multiple
                    outlined
                    hide-details
                    dense
                    chips
                    deletable-chips
                    item-disabled
                    :disabled="newAudit.type !== 'ACCOUNTING_REVIEW_MANUAL_CUSTOM'"
                />
            </v-col>
            <v-col cols="1" />
        </v-row>
        <div v-if="!newAudit.data.description">
            <v-row v-for="(row, index) of newAudit.data.form.tables[0].rows" :key="index">
                <v-col cols="3" class="d-flex align-center justify-end">
                    <h3 v-if="index === 0">Questions :</h3>
                </v-col>
                <v-col cols="8" class="d-flex align-center justify-center">
                    <v-textarea-filled
                        v-model="row.description"
                        auto-grow
                        rows="1"
                        hide-details
                        outlined
                        :label="`Question n&#xb0;${index + 1}`"
                        :disabled="newAudit.type !== 'ACCOUNTING_REVIEW_MANUAL_CUSTOM'"
                    />
                </v-col>
                <v-col cols="1" class="d-flex align-center justify-end">
                    <v-btn-trash
                        @click="deleteQuestion(row)"
                        class="mx-2 my-2"
                        v-if="!readOnly && newAudit.data.form.tables[0].rows.length > 1"
                        size="x-small"
                    >
                    </v-btn-trash>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="11" />
                <v-col cols="1" class="d-flex align-center justify-end">
                    <v-btn-add-icon
                        size="x-small"
                        @click="addQuestion()"
                        :disabled="
                            !newAudit.data.form.tables[0].rows[
                                newAudit.data.form.tables[0].rows.length - 1
                            ].description
                        "
                        v-if="!readOnly"
                    >
                    </v-btn-add-icon>
                </v-col>
            </v-row>
        </div>
        <v-row v-if="!newAudit.data.description">
            <v-col
                v-for="option of newAudit.data.options"
                :key="option.name"
                cols="4"
                class="d-flex align-center justify-center flex-wrap"
            >
                <v-switch
                    v-model="option.value"
                    :label="option.name"
                    hide-details
                    :disabled="newAudit.type !== 'ACCOUNTING_REVIEW_MANUAL_CUSTOM'"
                    size="small"
                />
            </v-col>
        </v-row>
    </v-card-text>
</template>

<script lang="ts">
import { User } from "../../store/store";

import UPSERT_AUDIT_CHECK from "../../graphql/audit/UpsertAuditCheck.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["newAudit", "editAudit"],
})
export class AuditCheckEdition extends Vue {
    @Prop({ default: false }) editMode: boolean;
    @Prop({ default: null }) auditToEdit: any;
    @Prop({ default: null }) auditToDisplay: any;
    @Prop({ default: false }) readOnly: boolean;

    newQuestionKey: number = 0;

    newAudit: any = {
        modified: false,
        type: "ACCOUNTING_REVIEW_MANUAL_CUSTOM",
        title: "",
        data: {
            accountableAccounts: [],
            options: [
                {
                    name: "Commentaire court",
                    value: false,
                },
                {
                    name: "Commentaire long",
                    value: false,
                },
                {
                    name: "Ajout d'OD",
                    value: true,
                },
            ],
            form: {
                tables: [
                    {
                        size: 12,
                        rows: [
                            {
                                key: `${this.newQuestionKey++}`,
                                code: "-",
                                description: "",
                                values: [
                                    {
                                        key: `${this.newQuestionKey}-1`,
                                        type: "radio",
                                        values: [
                                            {
                                                text: "Oui",
                                                value: "yes",
                                            },
                                            {
                                                text: "Non",
                                                value: "no",
                                            },
                                            {
                                                text: "N/A",
                                                value: "na",
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
    };

    get currentUser(): User {
        return this.$store.state.user;
    }

    get accountingFirmId() {
        if (this.currentUser.company.accountingFirm) {
            return this.currentUser.company.id;
        }
        return;
    }

    get accountingFirm() {
        if (this.currentUser.company.accountingFirm) {
            return this.currentUser.company.accountingFirm;
        }
        return;
    }

    beforeMount() {
        if (this.auditToEdit) {
            this.newAudit = JSON.parse(JSON.stringify(this.auditToEdit));
        } else if (this.auditToDisplay) {
            this.newAudit = JSON.parse(JSON.stringify(this.auditToDisplay));
        }
    }

    addQuestion() {
        this.newAudit.data.form.tables[0].rows.push({
            key: `${this.newQuestionKey++}`,
            code: "-",
            description: "",
            values: [
                {
                    key: `${this.newQuestionKey}-1`,
                    type: "radio",
                    values: [
                        { text: "Oui", value: "yes" },
                        { text: "Non", value: "no" },
                        { text: "N/A", value: "na" },
                    ],
                },
            ],
        });
    }

    deleteQuestion(question: any) {
        if (this.newAudit.data.form.tables[0].rows.length > 1) {
            const index = this.newAudit.data.form.tables[0].rows.indexOf(question);
            if (index >= 0 && index < this.newAudit.data.form.tables[0].rows.length) {
                this.newAudit.data.form.tables[0].rows.splice(
                    this.newAudit.data.form.tables[0].rows.indexOf(question),
                    1,
                );
            }
        }
    }

    resetNewAudit() {
        this.newAudit = {
            modified: false,
            type: "ACCOUNTING_REVIEW_MANUAL_CUSTOM",
            title: "",
            data: {
                accountableAccounts: [],
                options: [
                    { name: "Commentaire court", value: false },
                    { name: "Commentaire long", value: false },
                    { name: "Ajout d'OD", value: true },
                ],
                form: {
                    tables: [
                        {
                            size: 12,
                            rows: [
                                {
                                    key: `${this.newQuestionKey++}`,
                                    code: "-",
                                    description: "",
                                    values: [
                                        {
                                            key: `${this.newQuestionKey}-1`,
                                            type: "radio",
                                            values: [
                                                { text: "Oui", value: "yes" },
                                                { text: "Non", value: "no" },
                                                { text: "N/A", value: "na" },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            },
        };
    }

    validateNewAudit() {
        this.$emit("newAudit", JSON.parse(JSON.stringify(this.newAudit)));
        this.resetNewAudit();
    }

    validateModificatedAuditRow() {
        this.$emit("editAudit", JSON.parse(JSON.stringify(this.newAudit)));
        this.resetNewAudit();
    }

    saveAuditModifications() {
        this.upsertAuditCheck(this.newAudit);
    }

    async upsertAuditCheck(audit) {
        const result = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK,
            variables: {
                accountingFirmId: this.accountingFirmId,
                key: audit.key,
                data: audit.data,
                title: audit.title,
                type: audit.type,
                scope: "accountingPeriodClosing",
            },
        });

        if (result) {
            console.log("Modifications enregistrées pour l'audit : ", audit.key);
        }
    }
}

export default toNative(AuditCheckEdition);
</script>
